import React, { Component } from 'react';
import './index.css'
import * as actions from '../../actions/BlogActions'
import { connect } from 'react-redux';
import ModalRoot from '../Modal/ModalRoot';
import { hideModal, showModal } from '../../actions/ModalActions';

class BlogItem extends Component {

    componentDidMount() {
        var { match } = this.props;
        var id = match.params.id;
        this.props.getBlogItem(id)
    }

    closeModal = () => {
        this.props.hideModal();
    }


    openModal = (blog) => {
        this.props.showModal({
            open: true,
            closeModal: this.closeModal,
            blog: blog
        }, 'view')
    }

    openModalDelete = (blog) => {
        this.props.showModal({
            open: true,
            closeModal: this.closeModal,
            blog: blog
        }, 'alert')
    }

    render() {
        var { blog } = this.props;
        return (
            <div className="product__detail-page pt-2 pb-5">
                <div className="container">
                    <div className="row page__detail--content">
                        <div className="col-12">
                            <h3 className="account__page--title">Blog Detail</h3>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <h3 className="blog__page--detail-title">
                                {blog.title}
                            </h3>
                            <div className="news__content--heading">
                                <p className="news__content--date">
                                    <i className="far fa-calendar" />
                                    <span>{blog.createDate}</span>
                                </p>
                                <p className="news__content--author">
                                    <i className="fas fa-at" />
                                    <span>{blog.author}</span>
                                </p>
                            </div>
                            <div className="blog__page--detail-main">
                                <p className="blog__page--detail-text">
                                    {blog.description}
                                </p>
                                <div className="blog__page--detail-img">
                                    <img alt="" src={blog.img} />
                                </div>
                                <p className="blog__page--detail-text">
                                    {blog.description}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="page__detail--actions mt-5">
                                <h3 className="page__detail--actions-title">Actions: </h3>
                                <button 
                                    className="btn btn-outline-info btn-edit mr-3"
                                    onClick={() => this.openModal(blog)}
                                >Edit
                                </button>
                                <button 
                                    className="btn btn-outline-warning btn-delete"
                                    onClick={() => this.openModalDelete(blog)}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalRoot hideModal={this.props.hideModal} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        blog: state.blogs.blogItem
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getBlogItem: (id) => {
            dispatch(actions.fetchAPIBlogItem(id))
        },
        showModal: (modalProps, modalType) => {
            dispatch(showModal({ modalProps, modalType }))
        },
        hideModal: () => {
            dispatch(hideModal())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BlogItem);
